import { render, staticRenderFns } from "./AirConComponentBasic.vue?vue&type=template&id=4a823e1e"
import script from "./AirConComponentBasic.vue?vue&type=script&lang=js"
export * from "./AirConComponentBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports